// ============================================
// TOKEN & AUTHENTICATION UTILITY FUNCTIONS
// ============================================

/**
 * Check if token is valid (exists in localStorage)
 */
export const isTokenValid = () => {
  const token = localStorage.getItem("token");
  return !!token;
};

/**
 * Logout user - Clear all auth data from localStorage
 */
export const logoutUser = () => {
  // Clear all authentication data
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("user");
  localStorage.removeItem("userId");
  
  // Redirect to login page
  window.location.href = "/";
};

/**
 * Handle API errors related to token expiration
 * If API returns 401 (Unauthorized), logout the user
 */
export const handleAPIError = async (response) => {
  if (response.status === 401) {
    // Token expired or invalid
    console.warn("Token expired - Logging out user");
    logoutUser();
    return null;
  }
  
  // Return response for other error codes
  return response;
};

/**
 * Secure Fetch Wrapper - Handles token expiration automatically
 * Usage: secureApiFetch(url, options)
 */
export const secureApiFetch = async (url, options = {}) => {
  try {
    const token = localStorage.getItem("token");
    
    // Prepare headers with authorization
    const headers = {
      "Content-Type": "application/json",
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    // Merge options
    const config = {
      ...options,
      headers,
    };

    // Make the request
    const response = await fetch(url, config);

    // Handle 401 Unauthorized - Token expired
    if (response.status === 401) {
      console.error("Token expired - User will be logged out");
      logoutUser();
      return null;
    }

    return response;
  } catch (error) {
    console.error("API Request Error:", error);
    throw error;
  }
};

/**
 * Check Token Validity on App Start
 * Call this in App.js or main component
 */
export const validateTokenOnStartup = () => {
  const token = localStorage.getItem("token");
  
  if (!token) {
    // No token found, user should login
    return false;
  }
  
  // Token exists, user is authenticated
  return true;
};

/**
 * Get Authorization Headers
 */
export const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};
